import React, { useEffect, useState } from 'react';
import Modal from '@/components/Modal';
import { idleTimeoutModal } from '@/utils/translations';

interface IdleTimeoutModalProps {
  isOpen: boolean;
  onStayActive: () => void;
  getRemainingTime: () => number;
}

const IdleTimeoutModal: React.FC<IdleTimeoutModalProps> = ({
  isOpen,
  onStayActive,
  getRemainingTime
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (!isOpen) return;

    const tick = () => setRemainingSeconds(Math.max(0, Math.ceil(getRemainingTime() / 1000)));
    tick();
    const intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [isOpen, getRemainingTime]);

  return (
    <div onMouseMove={isOpen ? onStayActive : undefined}>
      <Modal
        isOpen={isOpen}
        onClose={onStayActive}
        headerText={idleTimeoutModal.title}
        headerVariant="xxl-medium">
        <div className="flex flex-col gap-y-2 pt-4">
          <p className="text-sm leading-5 text-dark-navy-30">
            {idleTimeoutModal.bodyPrefix}
            <span className="font-medium">{idleTimeoutModal.remainingLabel(remainingSeconds)}</span>
            {idleTimeoutModal.bodySuffix}
          </p>
          <p className="text-sm font-medium leading-5 text-emerge-navy-2">
            {idleTimeoutModal.stayActiveHint}
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default IdleTimeoutModal;
